export default "__VITE_ASSET__DmKsbL8j__"